<template>
  <b-navbar v-if="isAdmin" class="py-md-0 py-lg-0 py-xl-0" toggleable="sm" type="light" variant="light">
    <b-navbar-brand class="nav-logo" to="/admin">
      <SHIcons name="logo" iconColor="#E50012" width="50" height="50"/>
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="navbar-left">
        <b-nav-item to="/admin">
          <div class="nav-item-flex d-flex flex-column justify-content-around">
            <SHIcons name="home" width="32" height="32"/>
            <div class="nav-item-label">ホーム</div>
          </div>
        </b-nav-item>
        <b-nav-item to="/admin/Announcements">
          <div class="nav-item-flex d-flex flex-column justify-content-around">
            <SHIcons name="bell" width="32" height="32"/>
            <div class="nav-item-label">お知らせ</div>
          </div>
        </b-nav-item>
        <b-nav-item to="/admin/Achievements">
          <div class="nav-item-flex d-flex flex-column justify-content-around">
            <SHIcons name="dictionary" width="32" height="32"/>
            <div class="nav-item-label">成果管理</div>
          </div>
        </b-nav-item>
        <b-nav-item to="/admin/Students">
          <div class="nav-item-flex d-flex flex-column justify-content-around">
            <SHIcons name="parson" width="32" height="32"/>
            <div class="nav-item-label">修了生管理</div>
          </div>
        </b-nav-item>
        <b-nav-item to="/admin/Administrators">
          <div class="nav-item-flex d-flex flex-column justify-content-around">
            <SHIcons name="parson" width="32" height="32"/>
            <div class="nav-item-label">運営者管理</div>
          </div>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <template #button-content>
            <div class="nav-item-dropdown-button d-flex justify-content-around align-items-center">
              <SHIcons name="parson" width="32" height="32"/>
              <div>{{ loginUserName }}</div>
            </div>
          </template>
          <b-dropdown-item to="/admin/Configs">設定</b-dropdown-item>
          <b-dropdown-item to="/admin/terms">利用規約</b-dropdown-item>
          <b-dropdown-item @click.prevent.stop="logout">ログアウト</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
  <b-navbar v-else class="py-md-0 py-lg-0 py-xl-0" toggleable="sm" type="light" variant="light">
    <b-navbar-brand class="nav-logo" to="/student">
      <SHIcons name="logo" iconColor="#E50012" width="50" height="50"/>
    </b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav class="navbar-left">
        <b-nav-item to="/student">
          <div class="nav-item-flex d-flex flex-column justify-content-around">
            <SHIcons name="home" width="32" height="32"/>
            <div class="nav-item-label">ホーム</div>
          </div>
        </b-nav-item>
        <b-nav-item to="/student/Announcements">
          <div class="nav-item-flex d-flex flex-column justify-content-around">
            <SHIcons name="bell" width="32" height="32"/>
            <div class="nav-item-label">お知らせ一覧</div>
          </div>
        </b-nav-item>
        <b-nav-item to="/student/Achievements">
          <div class="nav-item-flex d-flex flex-column justify-content-around">
            <SHIcons name="dictionary" width="32" height="32"/>
            <div class="nav-item-label">成果管理</div>
          </div>
        </b-nav-item>
        <b-nav-item to="/student/Portofolios">
          <div class="nav-item-flex d-flex flex-column justify-content-around">
            <SHIcons name="earth" width="32" height="32"/>
            <div class="nav-item-label">ポートフォリオ</div>
          </div>
        </b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-nav-item-dropdown right>
          <template #button-content>
            <div class="nav-item-dropdown-button d-flex justify-content-around align-items-center">
              <SHIcons v-if="!pfIcoDataURL" name="parson" width="32" height="32"/>
              <b-img v-else :src="pfIcoDataURL" class="mr-1 border" width="38" height="38" rounded="circle" style="object-fit: cover" alt="Circle image"></b-img>
              <div>{{ loginUserName }}</div>
            </div>
          </template>
          <b-dropdown-item to="/student/Configs">設定</b-dropdown-item>
          <b-dropdown-item to="/student/Profile">プロフィール</b-dropdown-item>
          <b-dropdown-item to="/student/terms">利用規約</b-dropdown-item>
          <b-dropdown-item @click.prevent.stop="logout">ログアウト</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import SHIcons from '@/components/ico/SHIcons.vue'

export default {
  components: {
    SHIcons
  },
  props: {
    isAdmin: {
      type: [Boolean, Number, String],
      default: false
    },
    loginUserName: {
      type: String,
      default: null
    },
    logout: {
      type: Function,
      default: () => {}
    },
    pfIcoDataURL: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
nav {
  text-align: center;
}

.navbar {
  background: #ffffff !important;
}

.nav-logo {
  margin: 0 100px 0 50px;
}

.navbar-left .nav-item {
  width: 150px;
  height: 80px;
  font-size: 0.8rem;
  font-weight: bold;
}

.navbar-left .nav-item > a {
  height: 100%;
  padding-top: 10px;
  padding-bottom: 0;
}

.navbar-left .nav-item .nav-item-flex {
  height: 100%;
}

/* アイコンカラーはCSSで変更する */
.navbar-left .nav-item .nav-link:not(.router-link-exact-active) ::v-deep svg {
  fill: #a2afc1 !important;
}
.navbar-left .nav-item .nav-link:not(.router-link-exact-active) .nav-item-label {
  color: #a2afc1 !important;
}

.navbar-left .nav-item .router-link-exact-active .nav-item-flex {
  border-bottom: solid 3px #33537E;
}
.navbar-left .nav-item .router-link-exact-active .nav-item-label {
  color: #33537E;
}

li.nav-item.b-nav-dropdown.dropdown ::v-deep a.nav-link.dropdown-toggle {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

/* ドロップダウンの矢印を消す */
li.nav-item.b-nav-dropdown.dropdown ::v-deep a.nav-link.dropdown-toggle:after {
  content: none;
}

.nav-item-dropdown-button {
  height: 50px;
  padding: 5px 12px 5px 5px;
  border-radius: 25px;
  border: solid 3px;
  font-weight: bold;
}
</style>
